// RouterForwarder.js
import React from "react";
import PropTypes from "prop-types";

class RouterForwarder extends React.Component {
  render() {
    return React.Children.map(this.props.children, (child) => React.cloneElement(child, { context: this.props.context }));
  }
}

RouterForwarder.propTypes = {
  context: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default RouterForwarder;
